export default __webpack_public_path__ + "static/media/ico_warning.dbf95204.svg";